
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...name]",
      function () {
        return require("private-next-pages/[...name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...name]"])
      });
    }
  